import { Component, effect, input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbOptionModule } from 'mdb-angular-ui-kit/option';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { TranslateModule } from '@ngx-translate/core';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { SelectorModel } from '../../../models/table-column.model';
import { AModel } from '../../../models/resources/a-model';
import { AResourceService } from '../../../services/resources/a-resource.service';
import { UrlParamModel } from '../../../models/url-param.model';

@Component({
  selector: 'app-api-select',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MdbFormsModule,
    MdbOptionModule,
    MdbSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    MdbValidationModule,
  ],
  templateUrl: './api-select.component.html',
  styleUrls: ['./api-select.component.scss'],
})
export class ApiSelectComponent implements OnInit {
  id = input.required<string>();
  label = input.required<string>();
  controlName = input.required<string>();
  formGroup = input.required<FormGroup>();
  optionLabelSelector = input.required<SelectorModel[]>();
  optionValueSelector = input<string | undefined>();
  baseLink = input<string>();
  isRequired = input(false);
  hideLabel = input(false);
  placeholder = input<string | undefined>(undefined);
  searchService = input.required<AResourceService<AModel>>();
  searchServiceResourceUrl = input<string>();
  queryParams = input<UrlParamModel[]>([]);
  clearButton = input(false);
  multiple = input(false);
  optionsSelectedLabel = input<string>('OPTIONS_SELECTED');

  get selected(): AModel | AModel[] | null {
    return this.formGroup().get(this.controlName())?.value ?? null;
  }

  get selectedLink(): string | null {
    if (this.multiple()) return null;
    const selected = this.selected as AModel | null;
    if (!selected || !selected.id) return null;
    return `${this.baseLink()}/${selected.id}`;
  }

  private lastQueryParamsKey: string | null = null;

  constructor() {
    effect(() => {
      const params = this.queryParams();
      const key = JSON.stringify(params);
      if (this.lastQueryParamsKey !== key) {
        this.lastQueryParamsKey = key;
        this.loadOptions();
      }
    });
  }

  ngOnInit(): void {}

  loadOptions(): void {
    const service = this.searchService();
    service.getAll(
      {
        urlParams: this.queryParams(),
        paginated: false,
        resetData: true,
      },
      this.searchServiceResourceUrl() ?? null
    );
  }

  getOptionLabel(data: any): string {
    let result = '';
    this.optionLabelSelector().forEach((s: SelectorModel) => {
      let selectorResult = data;
      s.selector.split('.').forEach((sp) => {
        selectorResult = selectorResult?.[sp];
      });
      result += selectorResult ?? '';
      if (s.suffix) result += s.suffix;
    });
    return result;
  }

  getOptionValue(data: any): any {
    const selector = this.optionValueSelector();
    if (!selector) return data;
    let valueResult = data;
    selector.split('.').forEach((sp) => {
      valueResult = valueResult?.[sp];
    });
    return valueResult;
  }

  get control(): AbstractControl | null {
    return this.formGroup().get(this.controlName());
  }
}
